import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
var moment = require('moment'); // require
export default class List extends Component {
  state = {}

  componentDidMount = () => {
    this.load()
  };

  load = () => {
    var rest = new Rest(this)
    rest.request("event_options", "GET", {}, (res)=>{ 
      this.setState({
        data: res
      })
    })
  }

  delete = (id) => {
    var rest = new Rest(this)
    rest.request("event_options", "DELETE", {id:id}, (res)=>{
      this.load()
    })
  }
  
  render() {
    console.log(this.state)
    return (
      <Container>
          <Row className="mt-3 mb-3">
            <Col>
                <h4>All event options</h4>
            </Col>
          </Row>

          {
            this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
          }
          <Row>
              <Col>
                  <a className="btn btn-outline-primary m-1" href="/event_options/create">Add option</a>
                  <Table>
                      <thead>
                          <tr>
                              <th>ID</th> 
                              <th>name</th>
                              <th>Auto add</th>
                              <th>Consider when counting participants</th>
                              <th></th>
                          </tr>
                      </thead>
                      <tbody>
                          {
                            this.state.data && this.state.data.length && this.state.data.map(el=>{
                              return (
                                <tr key={el.id}>
                                    <td>
                                      {<a href={"/event_options/edit/"+el.id}>{el.id} <FaPen size={13} title="edit" /></a>}
                                    </td> 
                                   <td>{el.name}</td> 
                                   <td>{el.auto_add? "Yes": "No"}</td> 
                                   <td>{el.human? "Yes": "No"}</td> 
                                  <td>
                                    {["Bring guest", "Participation"].indexOf(el.name) == -1 && <div className="text-danger pointer" onClick={()=>this.delete(el.id)}><FaTrash size={13} title="edit"/> delete</div>}
                                    </td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                  </Table>
              </Col>
          </Row>
          
      </Container>
    );
  }
}
